<template>
  <div class="c-attributes">
    <el-select
      class="r-select dark"
      size="mini"
      v-model="config[field]"
      @change="updateData"
      :loading="loading"
      placeholder="Выберите атрибут"
      clearable
    >
      <el-option
        v-for="item in fields"
        :key="item.title"
        :value="item.title"
        :label="item.title"
      >
        <div style="display: flex; align-items: center;">
          <div :class="`c-attributes__icon ${item.type}`" />
          <r-text style="margin-left: 4px;">{{ item.title }}</r-text>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    fields() {
      return this.$store.state.calculations.objectFields[this.id] || [];
    }
  },
  methods: {
    async updateData(value) {
      if (!value) {
        this.$emit("update", value);

        return;
      }

      try {
        this.loading = true;

        await this.$cControllers.layers.updateFieldData(this.id, value);

        this.$emit("update", value);

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.c-attributes {
  &__icon {
    height: 16px;
    margin-right: 10px;
    width: 16px;
    background-size: 75%;
    background-position: 50%;
    opacity: 0.8;
    background-repeat: no-repeat;
    border-radius: 4px;

    &.string {
      background-image: url("../../../../assets/images/tree-attributes/types/string.svg");
      background-color: var(--string);
    }
    &.number {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--number);
    }
    &.numeric {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.integer {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.decimal {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.float {
      background-image: url("../../../../assets/images/tree-attributes/types/number.svg");
      background-color: var(--numeric);
    }
    &.boolean {
      background-image: url("../../../../assets/images/tree-attributes/types/boolean.svg");
      background-color: var(--boolean);
    }
    &.date {
      background-image: url("../../../../assets/images/tree-attributes/types/datetime.svg");
      background-color: var(--date);
    }
    &.time {
      background-image: url("../../../../assets/images/tree-attributes/types/interval.svg");
      background-color: var(--time);
    }
  }
}
</style>
